import React from "react";
import { IContactFromData } from "../../exports/interfaces";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";
import { formatUrl } from "../../exports/functions";
import DynamicToolTip from "../DynamicToolTip";

const ContactForm = (props: { contactFormData: IContactFromData[] }) => {
  const { companyDetailsData } = useCompanyDetailsContext();
  return (
    <section className="contact-page">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-5">
            <div className="contact-page__left">
              <div className="section-title text-left">
                <span className="section-title__tagline">
                  {props?.contactFormData[0]?.attributes?.Primary_Title}
                </span>
                <h2 className="section-title__title">
                  {props?.contactFormData[0]?.attributes?.Secondary_Title}
                </h2>
              </div>
              <p className="contact-page__text">
                {props?.contactFormData[0]?.attributes?.Description}
              </p>
              <div className="contact-page__social">
                <DynamicToolTip title="TwitterX">
                  <a
                    href={formatUrl(
                      companyDetailsData[0]?.attributes?.TwitterX_Link
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                </DynamicToolTip>
                <DynamicToolTip title="Facebook">
                  <a
                    href={formatUrl(
                      companyDetailsData[0]?.attributes?.Facebook_Link
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                </DynamicToolTip>
                <DynamicToolTip title="Instagram">
                  <a
                    href={formatUrl(
                      companyDetailsData[0]?.attributes?.Instagram_Link
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </DynamicToolTip>
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-lg-7">
            <div className="contact-page__right">
              <form className="comment-one__form contact-form-validated">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="comment-form__input-box">
                      <input
                        type="text"
                        placeholder="First Name*"
                        name="firstname"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="comment-form__input-box">
                      <input
                        type="text"
                        placeholder="Last Name*"
                        name="lastname"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="comment-form__input-box">
                      <input
                        type="email"
                        placeholder="Email Address*"
                        name="email"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="comment-form__input-box">
                      <input
                        type="number"
                        placeholder="Phone Number*"
                        name="phone"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="comment-form__input-box text-message-box">
                      <textarea
                        name="message"
                        placeholder="Message*"
                      ></textarea>
                    </div>
                    <div className="comment-form__btn-box">
                      <button
                        type="submit"
                        className="thm-btn comment-form__btn"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
